export default __webpack_public_path__ + "static/media/21.afe4bca8.png";